import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import ModalActUsuarioFiscal from "./modalUsuariosFiscal";
import axios from "axios";
import { Dimmer } from "../spinner";
import { CambiarClave } from "../configuracionGeneral/modalCambiarClave";
import { Mensaje } from "../mensajes";
import { Toasts } from "../toasts";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ID USUARIO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "USUARIO",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "NOMBRES",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaUsuariosFiscal() {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuarioH, setUsuarioH] = useState();
  const [persona, setPersona] = useState();
  const [organizacion, setOrganizacion] = useState();
  const [configCome, setConfigCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accusertim = JSON.parse(localStorage.getItem("accusertim"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setIdUsuario(obj.idusuario);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const seleccionarUsuarios = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/comun/getallusuariostimbre`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/comun/selectusuariotimbre?idusuario=${idusuario}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.idusuario > 0) {
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccionp,
            });
            setUsuarioH(response.data);
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      }).finally(()=> setActivate(false));
  };

  const gestionarUsuarios = (id, op) => (e) => {
    e.preventDefault();
    setOperacion(op);

    if (op === 4) {
      if (accusertim.substring(0, 1) !== "0") {
        setDeshabilitado(true);
        setIdUsuarioH(id);
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accusertim.substring(1, 2) !== "0") {
        setUsuarioH();
        setUsuariow();
        setPersona();
        setDeshabilitado(false);
        setMostrar(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accusertim.substring(2, 3) !== "0") {
        setDeshabilitado(false);
        setIdUsuarioH(id);
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accusertim.substring(3, 4) !== "0") {
        if (idUsuario === id) {
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto: "El Usuario no se puede eliminar porque esta logueado",
            icono: "informacion",
          });
          return;
        }
        setDeshabilitado(true);
        setIdUsuarioH(id);
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  /*  const renderizar = () => {
        seleccionarUsuarios();
        setUsuarioH('')
    }
 */
  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
    setActivate(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
    /*  renderizar(); */
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12" style={{ margin: 0 }}>
          <div className="container py-4">
            <div className="col-md-12 row m-0 mt-4">
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
              </div>

              <div className="col-md-3 ml-auto">
                <button
                  onClick={cambiarClave}
                  style={{
                    marginBottom: "10px",
                    pointerEvents:
                      accusertim.substring(2, 3) === "0" ? "none" : "cursor",
                  }}
                  className="btn btn-primary btn-sm rounded-pill"
                >
                  <i className="fas fa-key"> Cambiar Clave</i>{" "}
                </button>
              </div>
              <div className="col-md-1 ml-auto">
                <button
                  onClick={gestionarUsuarios("", 1)}
                  style={{ marginBottom: "5px" }}
                  className={
                    accusertim.substring(1, 2) === "0"
                      ? "btn btn-sm btn-secondary rounded-circle"
                      : "btn btn-sm btn-primary rounded-circle"
                  }
                >
                  <i className="fas fa-plus"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "50px" }}
                        >
                          {item.idusuario}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "250px" }}
                        >
                          {item.login}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "250px" }}
                        >
                          {item.nombres + " " + item.apellidos}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "90px" }}
                        >
                          <button
                            onClick={gestionarUsuarios(item.idusuario, 4)}
                            className={
                              accusertim.substring(0, 1) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-info rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarUsuarios(item.idusuario, 2)}
                            className={
                              accusertim.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarUsuarios(item.idusuario, 3)}
                            className={
                              accusertim.substring(3, 4) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <ModalActUsuarioFiscal
        show={mostrar}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        onHideRender={seleccionarUsuarios}
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <CambiarClave show={mostrar2} onHide={handleCloseClave} />
    </div>
  );
}

export default TablaUsuariosFiscal;



// WEBPACK FOOTER //
// ./src/components/permisosMdulos/tablaUsuariosFiscal.js